import React from 'react';

const About = () => {
  return <h2>This is the About Page!</h2>;
};

export default About;
